import { useInView } from '@/hooks/useInView';

export default function FadeIn({ children, delay = 0, className = '' }) {
  const [ref, visible] = useInView();

  return (
    <div
      ref={ref}
      className={`reveal ${visible ? 'visible' : ''} ${className}`}
      style={delay ? { transitionDelay: `${delay}s` } : undefined}
    >
      {children}
    </div>
  );
}
